<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col-12 md:col-12">
              <div class="">
                <div class="flex align-items-center">
                  <div class="ml-2">
                    <div class="text-xl text-primary font-bold">
                      {{ $t("Addition Information (International Applicants)") }}
                    </div>
                    <Divider></Divider>
                    <div class="text-purple-500">
                      <div class="font-bold text-yellow-500 mb-2">
                        {{ $t("instructions") }}
                      </div>
                      <ul>
                        <li>{{ $t("all_fields_marked_are_mandatory") }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col-12 md:col-12 sm:col-12 comp-grid">
            <div>
              <template v-if="!loading">
                <div class="grid">
                  <div class="col-12">
                    <form ref="observer" tag="form" @submit.prevent="startRecordUpdate()">
                      <div class="grid card nice-shadow-5">
                        <div class="col-12">
                          <div class="mb-1 text-cyan-700 font-bold text-md mb-2">
                          {{ $t("English proficiency") }}
                        </div>
                        <div class="text-sm">
                          International students whose Certificate/Diploma/Qualification are not in English shall be required to undertake a 3-months English proficiency organised by the university
                        </div>
                        </div>
                        <div class="col-12 md:col-6">
                          <div class="mb-2 font-bold text-sm">
                            {{ $t("Official Language") }} *
                          </div>
                          <div class="">
                            <!-- <div class="field mb-0"> -->
                            <Dropdown class="w-full" filter :class="getErrorClass('official_language')"
                              ref="ctrlofficial_language" optionLabel="label" optionValue="value"
                              v-model="formData.official_language" :options="$menus.official_language_list"
                              :label="$t('official_language')" :placeholder="$t('select')">
                            </Dropdown>
                            <!-- </div> -->
                          </div>
                        </div>
                        <div class="col-12 md:col-6">
                          <div class="mb-2 font-bold text-sm">
                            {{ $t("Language of Certificate") }} *
                          </div>
                          <div class="">
                            <!-- <div class="field mb-0"> -->
                            <Dropdown class="w-full" filter :class="getErrorClass('certificate_language')"
                              ref="ctrlcertificate_language" optionLabel="label" optionValue="value"
                              v-model="formData.certificate_language" :options="$menus.official_language_list"
                              :label="$t('certificate_language')" :placeholder="$t('select')">
                            </Dropdown>
                            <!-- </div> -->
                          </div>
                        </div>
                      </div>

                      <!-- <div class="col-12 md:col-6" v-if="formData.is_foreign_student == yes">
                            <div class="mt-3 mb-2 font-bold text-sm">
                              {{ $t("English Proficiency Certificate") }} *
                            </div>
                            <small class="text-xs text-primary">{{
                              $t("the_maximum_size_of_your_provided_national_id_must_not_be_more_than_10MB") }} .pdf .doc
                              .docx </small>
                            <br>
                            <div class="mt-2">
                              <Uploader :auto="true" :fileLimit="3" :class="getErrorClass('english_proficiency')"
                                :maxFileSize="10000000" accept=".pdf" :multiple="true" style="width: 100%"
                                :label="$t('choose_files_or_drop_files_here')"
                                upload-path="s3uploader/upload/english_proficiency"
                                v-model="formData.english_proficiency">
                              </Uploader>
                            </div>
                          </div> -->

                      <!-- GTEC Certificate Evaluation -->
                      <div class="card nice-shadow-5">
                        <div class="mb-1 text-cyan-700 font-bold text-md mb-2">
                          {{ $t("GTEC Certificate Evaluation") }}
                        </div>
                        <div class="text-sm">
                          All international students are required to have their certificates evaluated by the Ghana
                          Tertiary Education Commission. Admitted students must complete the evaluation of their
                          qualifications within the first three months of enrollment.
                        </div>
                        <div class="grid">
                          <div class="col-12 md:col-12">
                            <div class="mt-4 mb-2 font-bold text-sm">
                              {{ $t("Upload GTEC Certificate Evaluation") }}
                            </div>

                            <div class="mt-2">
                              <small class="text-xs text-primary">{{
                                $t("the_maximum_size_of_your_provided_national_id_must_not_be_more_than_10MB")
                              }} .pdf </small>
                              <br>
                              <div class="mt-2">
                                <Uploader :auto="true" :fileLimit="1"
                                  :class="getErrorClass('gtec_certificate_evaluation')" :maxFileSize="10000000"
                                  accept=".pdf,.docx,.doc" :multiple="false" style="width: 100%"
                                  :label="$t('choose_files_or_drop_files_here')"
                                  upload-path="s3uploader/upload/gtec_certificate_evaluation"
                                  v-model="formData.gtec_certificate_evaluation">
                                </Uploader>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <!-- Residence Permit -->
                      <div class="card nice-shadow-5">
                        <div class="mb-1 text-cyan-700 font-bold text-md mb-2">
                          {{ $t("Residence Permit") }}
                        </div>
                        <div class="text-sm">
                          All international student require a Ghanaian residence permit to pursue their programme.
                          International Students are required to visit the Dean of Student Affairs for arrangement to
                          obtain a Ghanaian residence permit upon arrival.
                        </div>
                        <div class="grid">
                          <div class="col-12 md:col-12">
                            <div class="mt-4 mb-2 font-bold text-sm">
                              {{ $t("Upload Residence Permit") }}
                            </div>

                            <div class="mt-2">
                              <small class="text-xs text-primary">{{
                                $t("the_maximum_size_of_your_provided_national_id_must_not_be_more_than_10MB")
                              }} .pdf </small>
                              <br>
                              <div class="mt-2">
                                <Uploader :auto="true" :fileLimit="1" :class="getErrorClass('residence_permit')"
                                  :maxFileSize="10000000" accept=".pdf,.docx,.doc" :multiple="false" style="width: 100%"
                                  :label="$t('choose_files_or_drop_files_here')"
                                  upload-path="s3uploader/upload/residence_permit" v-model="formData.residence_permit">
                                </Uploader>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>



                      <!--[form-content-end]-->
                      <div v-if="showSubmitButton" class="text-center my-3">
                        <Button type="submit" :label="$t('save_and_continue')" icon="pi pi-send" :loading="saving" />
                      </div>
                    </form>
                    <slot :submit="submit" :saving="saving"></slot>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="p-3 text-center">
                  <ProgressSpinner style="width: 50px; height: 50px" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import { mapActions, mapGetters, mapState } from "vuex";
import { ApplicantEditPageMixin } from "../../mixins/applicanteditpage.js";
import { PageMixin } from "../../mixins/page.js";
import { i18n } from "../../services/i18n.js";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "internationalAdditionalInfromationApplicantsPage",
  mixins: [PageMixin, ApplicantEditPageMixin],
  props: {
    pageName: {
      type: String,
      default: "applicants",
    },
    idName: {
      type: String,
      default: "applicant_id",
    },
    routeName: {
      type: String,
      default: "applicantsinternationaladditionalinfromation",
    },
    pagePath: {
      type: String,
      default: "applicants/internationaladditionalinfromation",
    },
    apiPath: {
      type: String,
      default: "applicants/internationaladditionalinfromation",
    },
    pageIndex: { type: Number, default: 8 },
  },
  data() {
    return {
      formData: {
        residence_permit: "",
        gtec_certificate_evaluation: "",
        official_language: "",
        certificate_language: "",
      },
      submitted: false,
    };
  },
  computed: {
    ...mapGetters("applicants", ["internationalAdditionalInfromationRecord"]),
    pageTitle: {
      get: function () {
        return this.$t("edit_applicants");
      },
    },
    apiUrl: function () {
      if (this.id) {
        return this.apiPath + "/" + encodeURIComponent(this.id);
      }
      return this.apiPath;
    },
  },
  validations() {
    let formData = {
      official_language: { required },
      certificate_language: { required },
      residence_permit: {},
      gtec_certificate_evaluation: {},
      // curriculum_vitae: {
      //     required: requiredIf(() => {
      //         const esit = this.formData.has_working_experience != this.none;
      //         return esit;
      //     }),
      // },
    };
    return { formData };
  },
  methods: {
    ...mapActions("applicants", ["updateInternationalAdditionalInfromation", "fetchInternationalAdditionalInfromation"]),
    load: function () {
      var url = this.apiUrl;
      this.loading = true;
      this.ready = false; // hide other components until main page is ready
      this.fetchInternationalAdditionalInfromation(url).then(
        (response) => {
          this.loading = false;
          this.ready = true;
          // this.academicDataRecord = response.data;
          this.formData = response.data;
          this.updateFormFields();
        },
        (response) => {
          this.resetForm();
          this.loading = false;
          this.showPageRequestError(response);
        }
      );
    },
    async startRecordUpdate() {
      this.submitted = true;
      const isFormValid = await this.v$.$validate();
      let payload = this.normalizedFormData();

      if (!isFormValid) {
        this.flashMsg(
          this.$t("please_complete_the_form"),
          this.$t("form_is_invalid"),
          "error"
        );
        return;
      }

      this.saving = true;
      let id = this.id;
      let url = this.apiUrl;
      let data = { id, url, payload };
      this.updateInternationalAdditionalInfromation(data).then(
        (response) => {
          this.saving = false;
          this.flashMsg(
            this.$t("information_was_updated"),
            this.$t("form_saved_successfully")
          );
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          this.$emit("next", this.pageIndex);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    updateFormFields: function () {
      //update form fields value after load from api
      //e.g convert fieldvalue (value,value2,value2) to array
    },
    resetForm() {
      //reset form fields value
      this.formData = {
        official_language: "",
        certificate_language: "",
        residence_permit: "",
        gtec_certificate_evaluation: "",
      };
    },
    getErrorClass(field) {
      if (this.v$.formData[field].$invalid && this.submitted) {
        return "p-invalid";
      }
      return "";
    },
  },
  watch: {},
  async mounted() {
    this.load();
  },
  async created() { },
};
</script>
<style scoped>
li {
  margin-top: 0.5em;
  line-height: 1.4em;
}
</style>
